import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "opentypefeature"
    }}>{`OpenTypeFeature`}</h1>
    <p>{`Supported OpenType feature options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LOW`}</strong>{` = 1701727351`}</p>
      <p parentName="blockquote">{`Low.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DISCRETIONARY_LIGATURES_FEATURE`}</strong>{` = 1330930764`}</p>
      <p parentName="blockquote">{`Allows the use of optional discretionary ligatures.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FRACTIONS_FEATURE`}</strong>{` = 1330931282`}</p>
      <p parentName="blockquote">{`Reformats numbers separated by a slash, such as 1/2, as fractions. Note: In some fonts, the fractions feature reformats only standard fractions. For information on reformatting non-standard fractions such as 4/13, see denominator feature and numerator feature.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ORDINAL_FEATURE`}</strong>{` = 1330933586`}</p>
      <p parentName="blockquote">{`Superscripts the alpha characters in ordinal numbers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SWASH_FEATURE`}</strong>{` = 1330934615`}</p>
      <p parentName="blockquote">{`Provides regular and contextual swashes, which may include alternate caps and end-of-word alternatives.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TITLING_FEATURE`}</strong>{` = 1330934857`}</p>
      <p parentName="blockquote">{`Activates alternative characters used for uppercase titles.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CONTEXTUAL_ALTERNATES_FEATURE`}</strong>{` = 1330930497`}</p>
      <p parentName="blockquote">{`Activates contextual ligatures and connecting alternates.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ALL_SMALL_CAPS_FEATURE`}</strong>{` = 1664250691`}</p>
      <p parentName="blockquote">{`Provides authentic small caps rather than scaled-down versions of the font's regular caps.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPERSCRIPT_FEATURE`}</strong>{` = 1884247123`}</p>
      <p parentName="blockquote">{`Sizes raised glyphs correctly relative to the surrounding characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUBSCRIPT_FEATURE`}</strong>{` = 1884247106`}</p>
      <p parentName="blockquote">{`Sizes lowered glyphs correctly relative to the surrounding characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NUMERATOR_FEATURE`}</strong>{` = 1884247118`}</p>
      <p parentName="blockquote">{`In a series of two numbers separated by a slash that form a non-standard fraction, such as 4/13, reformats the first number as a numerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DENOMINATOR_FEATURE`}</strong>{` = 1884247108`}</p>
      <p parentName="blockquote">{`In a series of two numbers separated by a slash that form a non-standard fraction, such as 4/13, reformats the second number as a denominator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TABULAR_LINING_FEATURE`}</strong>{` = 1330931284`}</p>
      <p parentName="blockquote">{`Gives full-height figures fixed, equal width.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PROPORTIONAL_OLDSTYLE_FEATURE`}</strong>{` = 1330933587`}</p>
      <p parentName="blockquote">{`Gives varying-height figures varying widths.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PROPORTIONAL_LINING_FEATURE`}</strong>{` = 1330932816`}</p>
      <p parentName="blockquote">{`Gives full-height figures varying widths.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TABULAR_OLDSTYLE_FEATURE`}</strong>{` = 1330933588`}</p>
      <p parentName="blockquote">{`Gives varying-height figures fixed, equal widths.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`DEFAULT_FIGURE_STYLE_FEATURE`}</strong>{` = 1330931268`}</p>
      <p parentName="blockquote">{`Applies the default figure style of the current font to figure glyphs.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OVERLAP_SWASH`}</strong>{` = 1330933590`}</p>
      <p parentName="blockquote">{`Overlap swash`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STYLISTIC_ALTERNATE`}</strong>{` = 1330934612`}</p>
      <p parentName="blockquote">{`Stylistic alternate`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JUSTIFICATION_ALTERNATE`}</strong>{` = 1330932309`}</p>
      <p parentName="blockquote">{`Justification alternate`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STRETCHED_ALTERNATE`}</strong>{` = 1330934610`}</p>
      <p parentName="blockquote">{`Stretched alternate`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      